import { AuctionScheduleDTO } from "../DTO/auctionScheduleDTO";
import { Address } from "../models/address";

export class AuctionAbstractDTO{

    public id!:number;
    public businessId!:string;
    public auctionIsLive:boolean = false;
    public auctionType?:number;
    public auctionStatus?:number;
    public scheduleSeqNo?:number;
    public reservePrice?:number;
    public buyerPremium?:number;
    public deposit?:number;
    public depositValue?:number;
    public propertyId!:number;
    public propertyHeader?:string;
    public propertyAddress?:Address;
    public caseNo?:string;
    public plaintiff?:string;
    public defendant?:string;
    public parcelId?:string;
    public appraisalAmount?:number;
    public imageReference?:string;
    public saleTypeId?:number;
    public propertyTypeId?:number;
    public legalAdRequired:boolean = false;
    public legalAdAllowsMultipleSales:boolean = false;
    public hasLegalAd:boolean = false;
    public legalAdConfirmed:boolean = false;
    public forceTownships:boolean = false;
    public readyForLegalAd:boolean = false;
    public readyForAuction:boolean = false;
    public legalAdNonComplianceReasons?:string;
    public auctionNonComplianceReasons?:string;

    public schedule:AuctionScheduleDTO[]=[];

    constructor(){

    }
}